import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { SECTION_IDS } from '../../constants';
import { useScrollSpy } from '../useScrollSpy';

type Result = ModelHookResult<
	{
		activeId: string | null;
	},
	{
		handleNavItemClick: (id: string) => void;
	}
>;

/**
 * Page-local wrapper around the generic `useScrollSpy` for the ambassadors side nav: tracks
 * `ambassadors_side_nav_click` for the clicked section before handing off to the scroll-spy's
 * `scrollToSection`.
 */
export function useSideNav(): Result {
	const track = useTracking();
	const {
		data: { activeId },
		actions: { scrollToSection },
	} = useScrollSpy(SECTION_IDS);

	const handleNavItemClick = useCallback(
		(id: string) => {
			void track('ambassadors_side_nav_click', { nav_section: id });
			scrollToSection(id);
		},
		[track, scrollToSection],
	);

	return {
		data: { activeId },
		actions: { handleNavItemClick },
	};
}
